const DEBUG_HOSTS = ['localhost', '192.168.43.89'];

export class Cookie {  

  public static set<T>(name: string, value: T, expires: Date = null) {

    if (expires == null) {
      expires = new Date();
      expires.setTime(expires.getTime() + (30 * 24 * 60 * 60 * 1000));
    }

    var exp = "expires=" + expires.toUTCString();    
    document.cookie = name + "=" + encodeURIComponent(JSON.stringify(value)) + ";" + exp + ";path=/";
  }

  public static get<T>(name: string, defaultValue: T = null) {

    let candidates: string[] = document.cookie.split(';').filter(i => i.trim().indexOf(name + '=') == 0);

    for (let i = 0; i < candidates.length; i++) {
      try { return JSON.parse(decodeURIComponent(candidates[i].split('=')[1].trim())); } catch (e) { }
    }

    return defaultValue;
  }

}
